import { FormControl, FormGroup, Validators } from '@angular/forms';

export class EmailVerificationForm extends FormGroup {
  constructor(verificationState: string) {
    super({
      verificationState: new FormControl(verificationState, [Validators.required]),
    });
  }

  get verificationState(): FormControl {
    return this.get('verificationState') as FormControl;
  }
}
